import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { ClinicProfileProvider } from '../../context/ClinicProfileContext';

const Layout = () => {
  return (
    <ClinicProfileProvider>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow pt-24 sm:pt-28">
          <Outlet />
        </main>
        <Footer />
      </div>
    </ClinicProfileProvider>
  );
};

export default Layout;
